import React from 'react';
import { Toast } from '../ui';
import { ActionErrorState } from '../../hooks/useActionError';

/** Bottom-right timed toast for a failed background action; fades on its own. */
export const ActionErrorToast: React.FC<{ state: ActionErrorState }> = ({ state }) =>
  state.error ? (
    <div className="fixed bottom-[88px] right-s6 z-50">
      <Toast
        key={state.error.key}
        timed
        status="danger"
        title={state.error.title}
        message={state.error.message}
        onDone={state.clear}
      />
    </div>
  ) : null;

export default ActionErrorToast;
